'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _class2, _temp, _initialiseProps;

var _mobx = require('mobx');

var _promiseDefer = require('promise-defer');

var _promiseDefer2 = _interopRequireDefault(_promiseDefer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Creates a confirmation request.
 */
var confirmationRequest = function confirmationRequest(opts) {
  return {
    deferred: (0, _promiseDefer2.default)(),
    options: opts || {}
  };
};

var ConfirmDialogState = (_class = (_temp = _class2 = function ConfirmDialogState(opts) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ConfirmDialogState);

  _initialiseProps.call(this);

  _mobx.extras.allowStateChanges(true, function () {
    (0, _assign2.default)(_this, opts);
  });
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  _initDefineProp(this, 'isOpened', _descriptor, this);

  this.no = function () {
    _this2._resolve(false);
  };

  this.yes = function () {
    _this2._resolve(true);
  };

  this.hide = (0, _mobx.action)(function () {
    _this2._resolve(false);
    _this2.isOpened = false;
  });
  this._resolve = (0, _mobx.action)(function (value) {
    if (!_this2.confirmationRequest) return;

    // Basically, sometimes we don't want to close the confirmation
    // dialog after getting confirmation.
    // In some cases we reuse the dialog with disabled buttons to
    // show progress updates.
    if (!_this2.confirmationRequest.options.manage) {
      _this2.isOpened = false;
    }

    _this2.confirmationRequest.deferred.resolve(value);
  });
  this.show = (0, _mobx.action)(function (opts) {
    if (_this2.confirmationRequest) {
      _this2.confirmationRequest.deferred.resolve(false);
    }

    _this2.confirmationRequest = confirmationRequest(opts);
    _this2.isOpened = true;
    return _this2.confirmationRequest.deferred.promise;
  });
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isOpened', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
exports.default = ConfirmDialogState;
//# sourceMappingURL=ConfirmDialogState.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ConfirmDialog/ConfirmDialogState.js
// module id = 250
// module chunks = 0